<template>

    <div class="container">


        <div class="handle-box-search">

            <el-row class="head-search">




                <el-col :span="12" style="margin-bottom: 10px;">
                    <span class="title">名称:</span>

                    <el-input
                            placeholder="请输入名称"
                            v-model="search_data.title"
                            style="width: 200px;"
                    ></el-input>
                </el-col>


            </el-row>


            <el-row class="head-search">


                <el-col :span="12" style="margin-bottom: 10px;">
                    <span class="title">创建时间:</span>

                    <el-date-picker
                            v-model="time"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            @change="timeChange"
                    >
                    </el-date-picker>
                </el-col>


            </el-row>


            <el-button type="primary" icon="el-icon-search" @click="consumerVoucherLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <!--            <el-button :icon="!loading?'el-icon-setting':'el-icon-loading'" @click="toExport" :disabled="loading">{{ !loading?'导出':'' }}</el-button>-->
        </div>


        <div class="searchInfo">
            <!-- 表格 -->
            <div>

                <el-table
                        :data="tableData"
                        style="width: 100%"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                >


                    <el-table-column
                            prop="voucher"
                            label="兑换码"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="title"
                            label="兑换卷名称"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="price"
                            label="兑换金额"
                    >
                        <template slot-scope="scope">
              <span style="color: rgb(233, 161, 6);">
                {{scope.row.price}}元
              </span>
                        </template>
                    </el-table-column>


                    <el-table-column
                            prop="city.name"
                            label="所属城市"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="consumer.name"
                            label="领取人"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="consumer.phone"
                            label="手机号"
                    >
                    </el-table-column>


                    <el-table-column
                            prop="time.YmdHis"
                            label="领取时间"
                    >
                    </el-table-column>

                </el-table>
            </div>

            <!-- 分页组件 -->
            <div class="pagination">
                <pages
                        :search_data="search_data"
                        :result_data="result_data"
                        @pages_function="pages_function"
                ></pages>
            </div>

        </div>
    </div>

</template>

<script>
    var _this;
    export default {
        data() {
            return {

                // 存放表格数据
                tableData: [],

                time:'',

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    title: '',
                    time_fixed: '',
                },


                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {
            _this = this;

            _this.consumerVoucherLists();
        },

        methods: {


            timeChange(val) {
                if (val != null) {
                    _this.search_data.time_fixed = JSON.stringify(['between'].concat(val));
                } else {
                    _this.search_data.time_fixed = '';
                }
            },


            // 搜索司机审核列表
            consumerVoucherLists() {
                console.log(_this.search_data);
                _this
                    .$post('/voucher/consumerVoucherLists', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                    })
                    .catch((err) => {
                    });
            },
            //翻页组件的回调
            pages_function(search_data) {
                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.consumerVoucherLists();
            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }
        }
    };
</script>

<style scoped>
</style>